import { useClient } from "../composables/useClient"
import { AppErrors, AppError, handleAppError } from "../utils/error"
import type { CreateUser } from "../utils/types"
import { UserSchema, JourneyDataSchema } from "../utils/types"

export const fetchJourney = async () => {
  const { GET } = useClient()
  const journeyStore = useJourneyStore()

  try {
    const { data, error } = await GET("/api/journey/me")

    if (error) {
      throw new AppError(AppErrors.FetchJourneyRequest)
    }

    const validation = JourneyDataSchema.safeParse(data)
    if (!validation.success) {
      console.log(validation.error.message)
      throw new AppError(AppErrors.FetchJourneyResponse)
    }

    journeyStore.setJourneyData(validation.data)
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.FetchJourney))
  }
}

export const fetchUser = async () => {
  const { GET } = useClient()
  const userStore = useUserStore()

  try {
    if (userStore.id && userStore.token) {
      const { data, error } = await GET("/api/journey/users/{id}", {
        params: {
          path: {
            id: userStore.id
          }
        }
      })

      if (error) {
        throw new AppError(AppErrors.ValidateUserRequest)
      }

      const validation = UserSchema.safeParse(data)
      if (!validation.success) {
        console.log(validation.error.message)
        throw new AppError(AppErrors.ValidateUserResponse)
      }

      userStore.setUser(validation.data.id, validation.data.token)
    } else {
      throw new AppError(AppErrors.ValidateUserStoreEmpty)
    }
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.ValidateUser))
  }
}

const createUser = async (ticketId: string, quest_name: string = "", story_name: string = "") => {
  const { POST } = useClient()
  const userStore = useUserStore()

  try {
    const requestBody: CreateUser = { user: { ticket_id: ticketId, quest_name: quest_name, story_name: story_name } }
    const { data, error } = await POST("/api/journey/users", {
      body: requestBody
    })

    if (error) {
      throw new AppError(AppErrors.CreateUserRequest)
    }

    const validation = UserSchema.safeParse(data)
    if (!validation.success) {
      console.log(validation.error.message)
      throw new AppError(AppErrors.CreateUserResponse)
    }

    userStore.setUser(validation.data.id, validation.data.token)
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.CreateUser))
  }
}

export const updateUser = async (userData: { first_name: string; last_name: string; email: string }) => {
  const { PUT } = useClient()
  const userStore = useUserStore()

  try {
    const requestBody = { user: userData }
    const { data, error } = await PUT("/api/journey/users", {
      body: requestBody
    })

    if (error) {
      throw new AppError(AppErrors.UpdateUserRequest)
    }

    const validation = UserSchema.safeParse(data)
    if (!validation.success) {
      console.log(validation.error.message)
      throw new AppError(AppErrors.UpdateUserResponse)
    }

    userStore.setUser(validation.data.id, validation.data.token)
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.UpdateUser))
  }
}

export const handleTicket = async () => {
  const search = window.location.search
  const searchParams = new URLSearchParams(search)
  const ticketId = searchParams.get("ticket_id")
  const quest = "QUEST_WORD_POSTFINANCE"
  const story = "Xaver"
  const origin = window.location.origin
  const isPostfinance =
      origin === "https://postfinance.brdge.ch" ||
      origin === "https://staging.naut-brdge-v2-frontend-postfinance.pages.dev"
      // origin.startsWith("http://localhost") ||
      // origin.startsWith("http://127.0.0.1")
  const isXaver =
      origin === "naut-brdge-v2-frontend-xaver.pages.dev" ||
      origin === "https://xaver.brdge.ch" ||
      origin === "https://staging.naut-brdge-v2-frontend-xaver.pages.dev"
      // origin.startsWith("http://localhost") ||
      // origin.startsWith("http://127.0.0.1")
    const isUbs =
      origin === "naut-brdge-v2-frontend-ubs.pages.dev" ||
      origin === "https://ubs.brdge.ch" ||
      origin === "https://staging.naut-brdge-v2-frontend-ubs.pages.dev" ||
        origin.startsWith("http://localhost") ||
        origin.startsWith("http://127.0.0.1")

  if (ticketId) {
    await createUser(ticketId)
  } else if (isPostfinance) {
    const ticketId = 'without_ticket'
    await createUser(ticketId, quest)
  } else if (isXaver) {
    const ticketId = 'without_ticket'
    await createUser(ticketId, "", story)
  } else if (isUbs) {
    const ticketId = 'without_ticket'
    await createUser(ticketId, '2026')
  }
}
